/*!
 * jQuery Textarea AutoSize plugin
 * Author: Javier Julio
 * Licensed under the MIT license
 *
 *
 * Modified by zawazawa
 */
;
(function ($, window) {

    const pluginName = "textareaAutoSize";
    const pluginDataName = "plugin_" + pluginName;

    const containsText = function (value) {
        return (value.replace(/\s/g, '').length > 0);
    };

    function Plugin(element) {
        this.element = element;
        this.$element = $(element);
        this.init();
    }

    Plugin.prototype = {
        init: function () {
            // var height = this.$element.outerHeight();
            const diff = parseInt(this.$element.css('paddingBottom')) +
                parseInt(this.$element.css('paddingTop')) || 0;

            if (containsText(this.element.value)) {
                this.$element.height(this.element.scrollHeight - diff);
            }

            let autosizePrev = 0;
            let autosizeCompactTimer = null;

            // keyup is required for IE to properly reset height when deleting text
            this.$element.on('input keyup', function () {
                const $window = $(window);
                const currentScrollPosition = $window.scrollTop();
                const textarea = this;
                if (autosizePrev < textarea.scrollHeight - diff) {
                    $(textarea).height(0).height(textarea.scrollHeight - diff);
                    $window.scrollTop(currentScrollPosition);
                    autosizePrev = textarea.scrollHeight - diff;
                }
                if (autosizeCompactTimer) {
                    clearTimeout(autosizeCompactTimer);
                }
                autosizeCompactTimer = setTimeout(function () {
                    autosizeCompactTimer = null;
                    $(textarea).height(0).height(textarea.scrollHeight - diff);
                    $window.scrollTop(currentScrollPosition);
                    autosizePrev = textarea.scrollHeight - diff;
                }, 1000);
            });
        }
    };

    $.fn[pluginName] = function () {
        this.each(function () {
            if (!$.data(this, pluginDataName)) {
                $.data(this, pluginDataName, new Plugin(this));
            }
        });
        return this;
    };

})(jQuery, window);
